import { SiteDto, SiteType } from '../../api/ClientApi';
import { RootState } from '../reducers';

export function getWarehouses(state: RootState): SiteDto[] | null {
    return state.sites.sites?.filter((s) => s.siteType === SiteType.Warehouse) ?? null;
}

export function getConstructionSites(state: RootState): SiteDto[] | null {
    return state.sites.sites?.filter((s) => s.siteType === SiteType.ConstructionSite) ?? null;
}
